import { useWeb3React } from "@web3-react/core";
import { ethers } from "ethers";
import { checkInContract, usdtContract } from "../contractor";
import { parseBNBHandle, parseUsdtHandle } from "../utils/utils";
import { Toast } from "react-vant";
import {
  useAccount,
  usePublicClient,
  useReadContract,
  useSendTransaction,
  useSwitchChain,
  useWriteContract,
  useConnections,
} from "wagmi";
import useConnectBscWallet from "./useConnectBscWallet";
import { useDispatch } from "react-redux";
import { isShowSwitchChainHandler } from "../../store/module/h5.config";

const useBscTransfer = () => {
  const { balanceData, chain, setBscSwitchChain } = useConnectBscWallet();
  const { address: account }: any = useAccount();
  const publicClient = usePublicClient();
  const { sendTransactionAsync } = useSendTransaction();
  const { writeContractAsync } = useWriteContract();
  const { switchChainAsync } = useSwitchChain();
  const connections = useConnections();
  const dispatch = useDispatch();
  const bnbTransferHandle = async (amount: string) => {
    if (!account) {
      console.log("Please connect to your wallet");
    } else {
      console.log("transfer for BNB");
      if (
        connections.length > 0 &&
        connections[0].chainId != import.meta.env.VITE_BSC_CHAIN_ID
      ) {
        dispatch(isShowSwitchChainHandler(true));
        return;
      }
      const value = parseBNBHandle(amount);
      if (balanceData && balanceData?.value <= value) {
        Toast.fail({
          message:
            "Your wallet balance is insufficient!  Please try again later.",
          forbidClick: true,
          className: "custom-toast",
        });
        return;
      }
      try {
        const hash = await sendTransactionAsync({
          to: import.meta.env.VITE_INVOICE_BSC_ADDRESS,
          value: value,
        });
        const receipt = await publicClient?.waitForTransactionReceipt({ hash });
        if (receipt && receipt?.status === "success") {
          return hash; // 返回交易哈希
        }
      } catch (e) {
        console.error("Transaction Error:", e);
      }
    }
  };

  const { abi, address }: any = usdtContract;
  // const usdtContractAddress: any = usdtContract.address;
  const balance: any = useReadContract({
    address: address,
    abi: abi,
    functionName: "balanceOf",
    args: [account],
  });
  const usdtBscTransferHandle = async (amount: string) => {
    if (!account) {
      console.log("Please connect to your wallet");
    } else {
      console.log("transfer for usdt");
      if (
        connections.length > 0 &&
        connections[0].chainId != import.meta.env.VITE_BSC_CHAIN_ID
      ) {
        dispatch(isShowSwitchChainHandler(true));
        return;
      }
      const value = parseUsdtHandle(amount); // 转账金额
      if (balance.data <= value) {
        Toast.fail({
          message:
            "Your wallet balance is insufficient!  Please try again later.",
          forbidClick: true,
          className: "custom-toast",
        });
        return;
      }

      try {
        const hash = await writeContractAsync({
          address: address,
          abi,
          functionName: "transfer",
          args: [import.meta.env.VITE_INVOICE_BSC_ADDRESS, value],
        });
        const receipt = await publicClient?.waitForTransactionReceipt({ hash });
        if (receipt && receipt?.status === "success") {
          return hash; // 返回交易哈希
        }
      } catch (e) {
        console.error("Transaction Error:", e);
      }

      // try {
      //     const value = parseUsdtHandle(amount); // 转账金额

      //     const signer = library.getSigner()
      //     const usdtContract = new ethers.Contract(address, abi, signer);
      //     const balance = await usdtContract.balanceOf(account);
      //     if (balance <= value) {
      //         Toast.fail({
      //             message: 'Your wallet balance is insufficient!  Please try again later.',
      //             forbidClick: true,
      //             className: 'custom-toast'
      //         })
      //         return
      //     }
      //     // 0xd70Da67639AF6928500bA8a89A893d9135fbe738
      //     const _tx = await usdtContract.transfer(import.meta.env.VITE_INVOICE_BSC_ADDRESS, value);
      //     const tx = await _tx.getTransaction()
      //     const receipt = await tx.wait()
      //     return receipt.transactionHash
      // } catch (error) {
      //     console.error('Transaction Error:', error);
      // }
    }
  };

  return {
    bnbTransferHandle,
    usdtBscTransferHandle,
    account,
  };
};

export default useBscTransfer;
